/* Version: 3.5.149 */
'use client';
import styled from 'styled-components';
import { FocusOutline } from '../../mixins/index.js';
import { rem } from '../../utils/functions.js';

var CheckboxWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__CheckboxWrapper",
  componentId: "sc-qwzu5h-0"
})(["display:flex;align-items:center;position:relative;margin:", ";", ""], function (_ref) {
  var hasChildren = _ref.hasChildren;
  return "3px ".concat(hasChildren ? '0' : '12px', " 3px 3px");
}, function (_ref2) {
  var checkboxStyle = _ref2.checkboxStyle;
  return checkboxStyle;
});
process.env.NODE_ENV !== "production" ? CheckboxWrapper.displayName = 'CheckboxWrapper' : undefined;
var CheckboxInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "styledComponents__CheckboxInput",
  componentId: "sc-qwzu5h-1"
})(["--error-bg:", ";flex-shrink:0;align-self:start;appearance:none;background:", ";border-style:solid;border-width:2px;border-color:", ";width:", ";height:", ";vertical-align:top;margin:0;cursor:pointer;&:hover,&:focus{border-width:2px;border-color:", ";}&:focus-visible{", ";}& + .checkbox-icon{display:none;}&:checked,&[data-indeterminate='true']{border-width:3px;border-color:", ";}&:checked + .checkbox-icon{display:block;}&[aria-invalid='true']{background:var(--error-bg);border-color:", ";}&:disabled,&:disabled:hover,&:disabled:focus{cursor:not-allowed;border-color:", ";background:", ";}"], function (_ref3) {
  var _theme$errors;
  var theme = _ref3.theme;
  return (_theme$errors = theme.errors) !== null && _theme$errors !== undefined && _theme$errors.showInputBackground ? "color-mix(in srgb, ".concat(theme.colorPalette.accentColor.shade_light_4, " 40%, white)") : theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, rem(28), rem(28), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, FocusOutline, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.utilityColors.error;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.checkbox.borderDisabled;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.checkbox.bgDisabled;
});
process.env.NODE_ENV !== "production" ? CheckboxInput.displayName = 'CheckboxInput' : undefined;
var ChildrenWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__ChildrenWrapper",
  componentId: "sc-qwzu5h-2"
})(["margin-left:12px;", ";"], function (_ref11) {
  var childrenStyle = _ref11.childrenStyle;
  return childrenStyle;
});
process.env.NODE_ENV !== "production" ? ChildrenWrapper.displayName = 'ChildrenWrapper' : undefined;
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-qwzu5h-3"
})(["position:absolute;top:0;left:0;width:", ";height:", ";line-height:", ";text-align:center;pointer-events:none;", ""], rem(28), rem(28), rem(28), function (_ref12) {
  var iconStyle = _ref12.iconStyle;
  return iconStyle;
});
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : undefined;

export { CheckboxInput, CheckboxWrapper, ChildrenWrapper, IconWrapper };
